import { RFValue } from "react-native-responsive-fontsize";

export default {
  COLORS: {
    ALERT: "#ec1414",
    ICON: '#876D56', //COR DOS CADEADOS E DAS SETAS PARA O LADO
    ICON_HEADER_PURCHASE: "#876D56", //COR DAS SETINHAS 
    BACKGROUND_HEADER: "none", //COR DE TODOS OS CABEÇALHOS
    //TELA CLICKCOURSE, PLANS e SIGNUP
    ICON_HEADER: "#876D56",  //COR DA PALAVRA ESCOLHER COMPRA, CADASTRAR-SE E COMPLETAR PAGAMENTO e VOLTAR da EDITPROFILE

    //CORES GERAIS
    PRIMARY_900: "#C69E4F", //COR PRINCIPAL DOS DETALHES DO APP - CHECKBOX, FECHAR TERMOS DE USO, ETC
    PRIMARY_800: "#876D56", //COR PRINCIPAL MAIS CLARA PARA INPUT LOGIN E ACTIVITY INDICATOR
    PRIMARY_700: "#F6EADD", //COR MAIS CLARA DO CLIENTE = COR PRINCIPAL MAIS CLARA PARA INPUT LOGIN E ACTIVITY INDICATOR
    TEXT_BUTTON: "#FFFFFF", //USADA PARA O TEXTO DOS BOTÕES LOGIN, CLICKCOURSE, SIGNUP - COR DE FUNDO É A PRIMARY_900

    //CORES DO DRAWER
    DRAWER_SELECTED: "#876D56", //COR DRAWER CLICADO E DO TEXTO DO DRAWER

    //TELAS: LOGIN, CLICKCOURSE, SIGNUP E PLANS
    BACKGROUND_ABOUT: "#FFFFFF", //COR PARA A ABOUT, DRAWER, CLICK COURSE, PLANS, EDITPROFILE, LOGIN E CADASTRO
    TITLE_ABOUT: '#2A2320', //TAMANHOS EXTRABIG, BIG E STANDARD
    TEXT_ABOUT: '#876D56', //TAMANHOS MEDIUM, SMALL E EXTRASMALL

    //TELA TERMOS DE USO
    BACKGROUND_TERMS: "#F6EADD", //COR PARA O FUNDO DOS TERMOS

    //TELA ABOUT - SECTION 5 - Plans
    S5_BACKGROUND: "#EEE3D5", //COR DE FUNDO DA SECTION 5
    S5_BACKGROUND_SELECTED: "#876D56", //COR DE FUNDO DO ITEM SELECIONADO DA FLATLIST MENSAL, TRI, ETC
    S5_BACKGROUND_NO_SELECTED: "  #C6A98D", //COR DE FUNDO DO ITEM NAO SELECIONADO DA FLATLIST MENSAL, TRI, ETC
    S5_TEXT_SELECTED: "#EEE3D5", //COR DO TEXTO DO ITEM SELECIONADO DA FLATLIST MENSAL, TRI, ETC
    S5_TEXT_NO_SELECTED: "#EEE3D5", //COR DO TEXTO DO ITEM NAO SELECIONADO DA FLATLIST MENSAL, TRI, ETC

    //TELA MAIN
    ICON_HEADER_CLICKCLASS: "#876D56", //COR DO ÍCONE VOLTAR DA CLICKCLASS
    ICON_HEADER_MAIN: "#876D56", //COR DO ICONE DRAWER
    BACKGROUND_MAIN: "#EEE3D5", //COR PARA A MAIN E CLICKCLASS
    TITLE_OVERPHOTO_MAIN: "#876D56", //USADA PARA O TÍTULO E SUBTÍTULO DA MAIN
    TITLE_MAIN: "#C69E4F", //USADA PARA PARA OS TAMANHOS EXTRABIG, BIG E STANDARD
    TEXT_MAIN: "#876D56", //USADA PARA PARA OS TAMANHOS MEDIUM, SMALL E EXTRASMALL

    //FOOTER TELA ABOUT E DRAWER
    BACKGROUND_FOOTER: "#C69E4F", //COR DO RODAPÉ
    TEXT_FOOTER: "#FFFFFF", //USADA PARA O TEXTO DO RODAPÉ

    GRADIENT_MAIN: [
      "rgba(0,0,0,0)",
      "rgba(0,0,0,0)",
      "rgba(0,0,0,0.1)",
      "#EEE3D5",
    ],

    //BOTÕES ARQUIVAR E PUBLICAR
    BACKGROUND_PUBLISH: "#C69E4F", //COR DO RODAPÉ
    BACKGROUND_ARCHIVE: "#876D56", //COR DO RODA
    TEXT_PUBLISH: "#FFFFFF", //USADA PARA O TEXTO DO RODAPÉ
    TEXT_ARCHIVE: "#FFFFFF", //USADA PARA O TEXTO DO RODAPÉ
  },

  FONTFAMILY: {
    BOLD: "text_Bold",
    MEDIUM: "text_Medium",
    REGULAR: "text_Regular",
    LIGHT: "text_Light",
    TITLE: "text_Title",
    SUBTITLE: "text_Subtitle",
    TEXTS: "text_Texts"
  },
  FONTSIZE: {
    EXTRABIG: RFValue(30, 980), //USADA 1X NA COURSES
    BIG: 26,
    STANDARD: 19,
    MEDIUM: 17,
    SMALL: 15,
    EXTRASMALL: 13,
  },
};
